/*
 * � 2020 Microsoft. All rights reserved.
 */

define('MenuUI/MonthlyAwardsTile',['pixi', 'absolute', 'tween', 'absolute/stringmanager', 'lodash', 'Solitaire/SolitaireGameMode', 'MenuUI/MenuTile',
        'MenuUI/Label', 'MenuUI/ColorConstants', 'MenuUI/MsftIconButton'],

    function (PIXI, Absolute, TWEEN, _s, _, SolitaireGameMode, MenuTile, Label, ColorConstants, MsftIconButton) {

        var MonthlyAwardsTile = function (config, monthData, year, month, menu) {
            var defaultConfig = {
                letterStyle: {
                    font: Absolute.ScreenMetrics.getResScale() * 30 + 'px Arial',
                    fontFamily: 'segoe',
                    fill: '#ffffff',
                    tint: 0xffffff,
                    align: 'left'
                }
            };
            this.initBackground();
            this.initMonthlyAwardsTile(_.extend(defaultConfig, config), monthData, menu);
            this.initDateInfo(year, month);
            this.initBadges();
            this.initInfoBox();
            window.addEventListener('mousedown', function (event) {
                if (MonthlyAwardsTile.lastInfoBox) MonthlyAwardsTile.lastInfoBox.visible = false;
            });
        };

        MonthlyAwardsTile.prototype = Object.create(MenuTile.prototype);

        MonthlyAwardsTile.prototype.initBackground = function () {
            this.background = PIXI.Sprite.fromFrame('awards/Awards-bkg.png');
        };

        MonthlyAwardsTile.prototype.initDateInfo = function (year, month) {
            this.year = year;
            this.month = month;
            var months = _s('months', null, true);
            var yearLabelText = new PIXI.Text('20' + year, this.config.letterStyle);
            var monthLabelText;

            if (Absolute.StringManager.getUserLanguage() === "fr-CA" || Absolute.StringManager.getUserLanguage() === "fr-FR") {
                monthLabelText = new PIXI.Text(
                    Absolute.StringManager('DailyChallenge.badgesOf') + ' ' + (months[parseInt(month) - 1]).toLowerCase(),
                    this.config.letterStyle
                );
            }
            else {
                monthLabelText = new PIXI.Text(
                    months[parseInt(month) - 1] + ' ' + Absolute.StringManager('DailyChallenge.badges'),
                    this.config.letterStyle
                );
            }
            
            this.monthLabel = new PIXI.Sprite(monthLabelText.generateTexture());
            this.monthLabel.position.x = Absolute.Coords.x(20);
            this.monthLabel.position.y = Absolute.Coords.y(15);

            this.yearLabel = new PIXI.Sprite(yearLabelText.generateTexture());
            this.yearLabel.alpha = 0.7;
            this.yearLabel.position.x = this.background.width - this.yearLabel.width - Absolute.Coords.x(20);
            this.yearLabel.position.y = Absolute.Coords.y(15);
            this.background.addChild(this.monthLabel);
            this.background.addChild(this.yearLabel);
        };

        MonthlyAwardsTile.prototype.initBadges = function () {
            this.badgesSprite = PIXI.Sprite.fromFrame('awards/' + this.getBadgesFrame() + '.png');
            this.badgesSprite.position.y = Absolute.Coords.y(70);
            this.badgesSprite.x = this.background.width / 2 - this.badgesSprite.width / 2;
            this.background.addChild(this.badgesSprite);
        };

        MonthlyAwardsTile.prototype.getKey = function () {
            return this.year + this.month;
        };

        MonthlyAwardsTile.prototype.initMonthlyAwardsTile = function (config, monthData, menu) {
            this.config = config;
            this.menu = menu;
            this.monthData = monthData;
            config.image = this.background;
            MenuTile.call(this, config);
        };

        MonthlyAwardsTile.prototype.handleClick = function () {
            this.infoBoxContainer.openBox();
            this.down = false;
            this.interactive = true;
        };

        MonthlyAwardsTile.prototype.initInfoBox = function () {
            this.infoBoxContainer = new PIXI.DisplayObjectContainer();
            var infoBox = new PIXI.Graphics(),
                offSet = Absolute.Coords.x(5),
                letterStyle = {
                    font: Absolute.ScreenMetrics.getResScale() * 22 + 'px Arial',
                    fontFamily: 'segoe',
                    fill: '#ffffff',
                    tint: 0x749dd2,
                    align: 'left'
                },
                currency = PIXI.Sprite.fromFrame('DC_kickoff_coin.png'),
                multiply = new PIXI.Text('X', letterStyle),
                number;
            number = new PIXI.Text(this.monthData.coinsEarned.toString(), letterStyle);
            // number = new PIXI.Text('100', letterStyle);
            infoBox.beginFill(0x000000);
            infoBox.lineStyle(3, 0xffffff, 1);
            infoBox.drawRect(0, 0, number.width + Absolute.Coords.x(62), Absolute.Coords.x(44));
            infoBox.endFill();
            currency.scale.set(0.45, 0.45);
            currency.x = offSet;
            currency.y = (infoBox.height - currency.height) / 2 - Absolute.Coords.y(1);
            multiply.x = currency.x + currency.width + Absolute.Coords.x(4);
            multiply.y = (infoBox.height - multiply.height) / 2 + Absolute.Coords.y(2);
            number.x = multiply.x + multiply.width + Absolute.Coords.x(4);
            number.y = (infoBox.height - number.height) / 2 + Absolute.Coords.y(1);
            this.infoBoxContainer.addChild(infoBox);
            infoBox.addChild(currency);
            infoBox.addChild(multiply);
            infoBox.addChild(number);
            this.infoBoxContainer.visible = false;
            this.infoBoxContainer.icon = currency;
            this.infoBoxContainer.coinCount = number;
            this.infoBoxContainer.multiply = multiply;
            this.currentWidth = this.infoBoxContainer.width;
            this.currentHeight = this.infoBoxContainer.height;

            var infoBoxContainer = this.infoBoxContainer;
            var self = this;
            this.infoBoxContainer.openBox = function () {
                if (MonthlyAwardsTile.lastInfoBox) MonthlyAwardsTile.lastInfoBox.visible = false;
                MonthlyAwardsTile.lastInfoBox = this.infoBoxContainer;
                infoBoxContainer.visible = !infoBoxContainer.visible;
                infoBoxContainer.x = this.width / 2 - this.infoBoxContainer.width / 2;
                infoBoxContainer.y = -infoBoxContainer.height;
                if (infoBoxContainer.visible) {
                    if(this.children.indexOf(this.infoBoxContainer) === -1) this.addChild(this.infoBoxContainer);
                    this.menu.handleResize();
                    new TWEEN.Tween({alpha: 0})
                        .easing(TWEEN.Easing.Cubic.InOut)
                        .to({alpha: 1}, 350)
                        .onUpdate(function (p) {
                            infoBoxContainer.alpha = this.alpha;
                        })
                        .start();
                    if (this.hideTimeout) clearTimeout(this.hideTimeout);
                    this.hideTimeout = window.setTimeout(function () {
                        self.hideInfoBoxContainer(infoBoxContainer);
                    }.bind(this), 3000);
                }
            }.bind(this);
        };

        MonthlyAwardsTile.prototype.hideInfoBoxContainer = function (infoBoxContainer) {
            new TWEEN.Tween({alpha: 1})
                .easing(TWEEN.Easing.Cubic.InOut)
                .to({alpha: 0}, 350)
                .start()
                .onUpdate(function (p) {
                    infoBoxContainer.alpha = this.alpha;
                })
                .onComplete(function () {
                    infoBoxContainer.visible = false;
                }).start();
        };

        MonthlyAwardsTile.prototype.resizeInfoBoxContainer = function () {
            this.infoBoxContainer.width = this.currentWidth * this.menu.container.children[0].pageGenerator.cardScale;
            this.infoBoxContainer.height = this.currentHeight * this.menu.container.children[0].pageGenerator.cardScale;
            this.updateInfoBoxContainerPosition();
        };

        MonthlyAwardsTile.prototype.updateInfoBoxContainerPosition = function () {
            this.infoBoxContainer.x = this.width / 2 - this.infoBoxContainer.width / 2;
            this.infoBoxContainer.y = -this.infoBoxContainer.height;
        };

        MonthlyAwardsTile.prototype.onShow = function () {
            this.statsModel.updateStats();
            this.showStats();
            this.interactive = this.hasMoreInfo;
        };

        MonthlyAwardsTile.prototype.getBadgesFrame = function () {
            var badgesCount = this.monthData.bronzeBadgesWon + this.monthData.silverBadgesWon
                + this.monthData.goldBadgesWon + this.monthData.diamondBadgesWon;
            switch (badgesCount) {
                case 4:
                    return 'badges_diamond';
                case 3:
                    return 'badges_gold';
                case 2:
                    return 'badges_silver';
                case 1:
                    return 'badges_bronze';
                case 0:
                    return 'badges_none';
            }
        };

        return MonthlyAwardsTile;

    });

